const common = {
    'common.sure': 'Confirmar',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.loading': 'Cargando...',
    'common.loading.noMore': 'No más~',
    'common.loading.loading1': 'Cargando',
    'common.success': 'Éxito',
    'common.fail': 'Fracaso',
    'common.unKnowError': 'Anomalía desconocida',
    'common.unitDayOdd': 'día',
    'common.unitDayPlural': 'días',
    'common.unitMonthOdd': 'mes',
    'common.unitMonthPlural': 'meses',
    'common.infiniteAct': 'La primera vez sin restricciones !',
    'common.label': 'Se acerca la promoción',
    'common.404': '¡Ups! ¡No se encontró la página solicitada!'
}
const language = {
    'lang.chinese': 'Chino',
    'lang.english': 'Inglés',
    'lang.germany': 'Alemán',
    'lang.spanish': 'Español',
    'lang.french': 'Francés',
    'lang.italian': 'Italiano',
    'lang.portuguese': 'Portugués',
}
// 登录页
const login = {
    'login.loginText': 'Iniciar sesión',
    'login.input.email': 'Correo(LenovoID)',
    'login.input.password': 'Contraseña',
    'login.tip.noAccount': '¿Aún no tiene cuenta?',
    'login.tip.toRegister': 'Ir a Registrarse',
    'login.tip.forget': 'Olvida la contraseña?',
    'login.check.noInfo': 'Error de correo o contraseña',
    'login.failed': 'Fracaso de inicio de sesión',
    'login.terms': 'Por favor revise los términos y condiciones',
    'login.banner.flow': 'Registrieren Sie sich jetzt und genießen Sie 1GB*6 Monate kostenlose Daten',
    'login.banner.VFflow': 'Registrieren Sie sich jetzt und genießen Sie 5GB*3 Monate kostenlose Daten',
    'login.banner.coming': 'Promotion kommt:',
    'login.banner.size': 'Los datos del primer mes son ilimitados'
}
// 注册页面
const register = {
    'register.registerText': 'Registrarse',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': 'Correo',
    'register.input.imgCode': 'Código de verificación de imagen',
    'register.input.verifyCode': 'Código de verificación',
    'register.input.password': 'Contraseña',
    'register.input.rePassword': 'Confirmar contraseña',
    'register.input.alRegister': 'Ya registrado',
    'register.input.toLogin': 'vaya a iniciar sesión.',
    'register.input.termsOfService': 'Términos de Uso',
    'register.input.privacyStatement': 'Declaracion de privacidad',
    'register.tip': 'Al crear una cuenta significa que usted acepta los {termsOfService} y la {privacyStatement}.',
    'register.tipForTablet': 'Al crear la cuenta, usted ha leído y aceptado las <a1>descripciones del Plan de precarga de datos</a1>, <a2> los términos y condiciones</a2> de Lenovo Connect, <a3>los términos y condiciones</a3> de HUE, <a4> la política de privacidad</a4> de Lenovo Connect, y <a5>la política de privacidad</a5> de HUE.',
    'register.sendMsg.text': 'Lograr código de verificación',
    'register.sendMsg.reSend': 'Enviar de nuevo',
    'register.sendMsg.sendSuccess': 'Enviado correctamente',
    'register.sendMsg.sendFailed': 'Fracasado a enviar',
    'register.check.noEmailField': 'Por favor ingrese su correo electrónico',
    'register.check.noImageCodeField': 'Por favor ingrese captcha de imagen',
    'register.check.noVerifyField': 'Ingrese el captcha que obtuvo',
    'register.check.noPasswdField': 'Por favor ingrese la contraseña',
    'register.check.noConfirmPasswd': 'Confirme la contraseña',
    'register.check.errorEmail': 'Error de correo',
    'register.check.errorImageCode': 'Error de código de verificación de imagen',
    'register.check.errorVerifyCode': 'Error de código de verificación',
    'register.check.errorPasswd': 'Error de contraseña',
    'register.check.errorTwoPasswd': 'Contraseña inconsistente',
    'register.success': 'se ha registrado exitosamente',
}
// 首页
const home = {
    'home.header.upload': 'Cargar',
    'home.header.iccid': 'Código ICCID',
    'home.flowUse.title': 'Actual Plan de Datos',
    'home.flowUse.status.title': 'Estado de Uso',
    'home.flowUse.status.used': 'Usado',
    'home.flowUse.status.remaining': 'Restante',
    'home.flowUse.dataPlan.key': 'Nombre de Plan de Datos',
    'home.flowUse.validity.key': 'Validez',
    'home.flowUse.note.key': 'Nota',
    'home.flowUse.note': 'Una vez que se alcance la asignación de datos en el ciclo actual, la conectividad se detendrá hasta el siguiente ciclo.',
    'home.flowUse.leftDay': '{day} {unit} remanente',
    'home.flowUse.currentDataPlan.title': 'Mi plan(es) de datos',
    'home.flowUse.currentDataPlan.titleHue': 'Mi paquete de servicio de conectividad',
    'home.flowUse.outDate': 'Se ha expirado el plan de datos',
    'home.flowUse.lock': 'La tarjeta SIM está bloqueada.',
    'home.flowUse.noDataPlan': 'datos no usados',
    'home.flowUse.status.unlimited': 'Infinito',
    'home.area.intro.titleHue': 'Completar',
    'home.area.intro.title': 'Recarga de datos',
    'home.area.intro.content': 'Nuestros planes pueden cubrir todos los países de la <cta>UE</cta> (Austria, Bélgica, Bulgaria, Croacia, Chipre, República Checa, Dinamarca, Estonia, Finlandia, Francia, Alemania, Grecia, Hungría, Irlanda, Italia, Letonia, Lituania, Luxemburgo, Malta, Países Bajos, Polonia , Portugal, Rumania, Eslovaquia, Eslovenia, España y Suecia), <cta>más Islandia, Noruega, Suiza, Reino Unido y Estados Unidos de América,</cta>.',
    'home.area.intro.contentHUE': 'Nuestros planes pueden cubrir todos los países de la <cta>UE</cta> (Austria, Bélgica, Bulgaria, Croacia, Chipre, República Checa, Dinamarca, Estonia, Finlandia, Francia, Alemania, Grecia, Hungría, Irlanda, Italia, Letonia, Lituania, Luxemburgo, Malta, Países Bajos, Polonia , Portugal, Rumania, Eslovaquia, Eslovenia, España y Suecia), <cta>más Islandia, Noruega, Suiza, Reino Unido,</cta>Habilite los datos móviles y el roaming (sin tarifa de roaming adicional).',
    'home.area.intro.vatIntro': 'Los precios incluyen IVA si aplicable',
    'home.area.intro.suggest': 'Sugerir',
    'home.area.switch.title': 'Región:',
    'home.active.title': 'Activar Mi Plan de Datos',
    'home.active.intro': 'El plan de datos de precarga "{packageContent}" debe ser activado dentro de los 90 días posteriores a la compra de la tarjeta SIM de coneccion de Lenovo. La validez de {timeLength} sigue inmediatamente a la activación.',
    'home.active.agree': 'Sí, he leído y aceptado la <a>descripción del plan de datos de precarga</a>, los <a1>términos y las condiciones</a1> y la <a2>política de privacidad</a2>. Lenovo Connect alimentado por Truphone.',
    'home.active.agreeForTablet': 'Sí, he leído y aceptado la <a>descripción del plan de datos de precarga</a>, los <a1>términos y las condiciones</a1> y la <a2>política de privacidad</a2>.',
    'home.active.btnText': 'Activar Ahora',
    'home.active.failed': 'Fracasado a activar!',
    'home.active.success': 'Activado correctamente',
    'home.active.success.btn': 'Entendido',
    'home.active.detail.title': 'Descripción de Plan de Datos',
    'home.active.detail.faq': 'Si tiene cualquier pregunta, por favor consulte el <a>Servicio al cliente</a>.',
}
// 我的页面
const me = {
    'me.signOut': 'Cerrar sesión',
    'me.nav.device': 'Mi Dispositivo(s)',
    'me.nav.package': 'Mi(s) Plan(es) de Datos',
    'me.nav.order': 'Mi(s) orden(es)',
    'me.nav.accountInfo': 'Mi Cuenta',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': 'Póngase en Contacto con Nosotros',
    'me.signOut.alert.title': 'Cerrar sesión',
    'me.signOut.alert.content': '¿Estás seguro de que quieres cerrar sesión?'
}
const suggest = {
    'suggest.title': 'Caja de sugerencias',
    'suggest.toast': 'Por favor ingrese el contenido',
    'suggest.success': 'Exitoso',
    'suggest.suggestions': 'Por favor comparta sus sugerencias o preguntas con nosotros',
    'suggest.submit': 'Enviar',
    'suggest.information': 'Información',
    'suggest.submission': 'mi presentación',
    'suggest.noMore': 'No más datos',
    'suggest.uploadImg': 'El tamaño de la imagen no debe exceder de 5 m',
}
// 套餐卡片
const packageCard = {
    'package.validDate': 'Validez de {timeLength} {dateUnit}',
    'package.validTo': 'Válido hasta{date} UTC',
    'package.orderBtnText': 'Comprar ahora',
    'package.extend.title': 'Extendido Plan de datos',
    'package.expand.title': 'Expandido Plan de datos',
    'package.extend.titleHue': 'Suscríbase a un paquete de servicio de conectividad mensual',
    'package.expand.titleHue': 'Agregue un paquete de servicio de conectividad adicional',
    'package.expand.add': 'Agregar',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Sí, he leído y acepto los <a>Términos y condiciones</a> y la <b>Política de privacidad</b>.',
    'packageDetail.privacyForTablet': 'Sí, he leído y acepto los <a>Términos y condiciones</a> y la <b>Política de privacidad</b>.',
    'packageDetail.description': 'Descripción de Plan de Datos',
    'packageDetail.expansionPackage.title': 'Expandir Actual Plan de Datos',
    'packageDetail.payBtn.text': 'Pago ahora',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Dirección de facturación histórica',
    'billAddress.fieldWrap.title': 'Introduzca su dirección de facturación',
    'billAddress.btn.continue': 'Continuar',
    'billAddress.btn.cancel': 'Cancelar',
    'billAddress.field.firstName': 'Primer nombre',
    'billAddress.field.lastName': 'Apellido',
    'billAddress.field.email': 'Correo',
    'billAddress.field.street': 'Calle',
    'billAddress.field.city': 'Ciudad',
    'billAddress.tips.payment': 'Cómo pagar?',
    'billAddress.tips.newCard': 'Nueva tarjeta',
    'billAddress.tips.oldCard': 'Tarjetas de crédito antiguas',
    'billAddress.field.state': 'Estado',
    'billAddress.field.postCode': 'Código Postal',
    'billAddress.field.country': 'País',
    'billAddress.field.firstNameError': 'El lugar de nombre (s) no puede estar vacío',
    'billAddress.field.lastNameError': 'El lugar de apellido no puede estar vacío',
    'billAddress.field.emailError': 'El lugar de correo no puede estar vacío',
    'billAddress.field.emailFormatError': 'Introduzca un correo electrónico válido',
    'billAddress.field.streetError': 'El lugar de calle no puede estar vacío',
    'billAddress.field.cityError': 'El lugar de ciudad no puede estar vacío',
    'billAddress.field.stateError': 'El lugar de Estado no puede estar vacío',
    'billAddress.field.postCodeError': 'El lugar de Código Postal no puede estar vacío',
    'billAddress.field.countryError': '国家是必填字段',
}
// 订单
const order = {
    'order.subType.1': 'Activar',
    'order.subType.2': 'Comprar',
    'order.subType.4': 'Redimir',
    'order.subType.5': 'Regalo',
    'order.subType.6': 'Orden empresarial',
    'order.subType.7': 'Prueba',
    'order.subType.8': 'Actualizar',
    'order.subType.9': 'Adicional',
    'order.subType.systemOrder': 'Orden de Sistema',
    'order.item.orderNum': 'Order No.',
    'order.item.content': 'Detalles',
    'order.item.orderType': 'Tipo de Orden',
    'order.item.validity': 'Validez',
    'order.item.subTotal': 'Subtotal',
    'order.item.vat': 'IVA',
    'order.item.totalFee': 'Total',
    'order.noInfo.message': 'Aún no hay planes comprados!',
    'order.noInfo.btnText': 'Volver a la página de inicio'
}
// 支付结果页
const payResult = {
    'pay.success': 'Pago exitoso',
    'pay.fail': 'Fracaso de pago',
    'pay.checkOrder': 'Verificar pedidos',
    'pay.back': 'Volver',
    'pay.continue': 'Continuar la compra',
}
// 我的设备页面
const device = {
    'device.switch': 'Cambiar dispositivo',
    'device.status.current': 'Dispositivo actual',
    'device.status.available': 'Dispositivo(s) disponible(s)',
    'device.switch.alert.title': 'Cambiar dispositivo',
    'device.switch.alert.content': '¿Estás seguro de cambiar a este dispositivo?',
    'device.noInfo.message': 'Sin dispositivos vinculados',
    'device.noInfo.btnText': 'Cargar código ICCID',
    'device.edit.prompt.message': 'Introduzca su apodo',
    'device.edit.check.none': 'El apodo no puede estar vacío',
}
// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Disponibles',
    'myDataPlan.tabbar.expired': 'Expirados',
    'myDataPlan.noAvailablePlan': 'Ahora no hay Plan(es) de Dato(s) disponibles',
    'myDataPlan.noExpiredPlan': 'Ahora no hay planes expirados',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'La longitud del apodo debe ser de 4 a 20 caracteres.',
    'account.account.fieldTitle': 'Cuenta',
    'account.nickName.fieldTitle': 'Apodo',
    'account.nickName.character': '4-20 caracteres, incluidas letras, números o símbolos.',
}
// FAQ页面
const FAQ = {
    'faq.question.1': '¿Puedo hacer llamadas o enviar SMS?',
    'faq.question.2': '¿Cómo puedo comprar un plan de datos y verificar mi registro de pedido?',
    'faq.question.3': '¿Cúales son las reglas de comprar un plan de datos?',
    'faq.question.4': '¿Cuáles son las formas de pago?',
    'faq.question.5': '¿Cómo puedo cerrar los datos si no quiero usarlos?',
    'faq.question.6': 'He comprado exitosamente un plan de datos, ¿por qué no puedo usarlo?',
    'faq.question.7': '¿Qué hago si no puedo poner acceso a Internet?',
    'faq.question.8': '¿En cúales países se pueden usar?',
    'faq.question.9': '¿Qué es la forma de contacto de Servicio al cliente?',
    'faq.question.10': '¿Cómo puedo solicitar una factura?',
    'faq.question.11': '¿Cómo se puede reemplazar la tarjeta de SIM?',
    'faq.question.12': '¿Hace falta pagar para reemplazar una tarjeta SIM?',
    'faq.question.13': '¿Puedo suspender el plan de datos activado si mi SIM se pierde, se rompe o falla?',
    'faq.question.14': '¿Qué hago si olvido la contraseña?',
    'faq.question.15': '¿Puedo hacer cambios después de que el ICCID de mi tarjeta SIM con mi ID de Lenovo?',
    'faq.question.16': '¿Qué debo hacer si el dispositivo me pide a introducir código PIN, PIN2 o PUK, o introducir APN?',
    'faq.question.17': '¿Cómo puedo verificar ICCID de mi tarjeta SIM?',
    'faq.question.18': 'Contáctenos',
    'faq.answer.1': 'La tarjeta SIM sólo soporta datos para acceso a red. No recibirá un número de móvil. Aún puede hacer una llamada o enviar SMS usado Aplicaciones como Skype, WhatsApp.',
    'faq.answer.2': 'Por favor visite aoacwap.lenovoconnect.com para verificar.',
    'faq.answer.3': 'Los planes de datos comprados con éxito se activarán automáticamente (Por ejemplo, Expandir mi plan de datos) o esperarán en la cola para ser activado (Por ejemplo Extender mi plan de datos). No soportamos el reembolso o la suspensión del plan de datos.',
    'faq.answer.4': 'Vendemos planes en GBP, EUR, USD,CHF, NOK, DKK, SEK y soportamos tarjeta de crédito/débio Visa o Master.',
    'faq.answer.5': 'Si usted quiere desactivar el servicio de acceso a internet por los datos, por favor haga clic en "Datos móviles" en la parte superior de la pantalla y desactive "Datos móviles".  no se terminará el cobro después de desactivar "Datos móviles".',
    'faq.answer.6.1': '1) Si el plan comprado es para extender su plan actual, sólo se puede activar una vez que expire su plan actual.',
    'faq.answer.6.2': '2) Si el plan comprado es para expandir su plan actual, debe ser activardo automáticamente. Por favor consulte otras preguntas frecuentes para problemas de conectividad o comuníquese con el Servicio al cliente de Lenovo.com en su propio país.',
    'faq.answer.6.3': '3) Si tiene varios dispositivos con el mismo ID de Lenovo, por favor asegúrese de que el plan de datos comprado esté bajo el ICCID de la tarjeta SIM del dispositivo utilizado actualmente .',
    'faq.answer.7.1': '1) Compruebe si"Datos móviles"está activado.',
    'faq.answer.7.2': '2) Compruebe si " Itinerancia de datos "está habilitado. Vaya a Configuración-> Red & Internet-> Red móvil->  Itinerancia de datos.',
    'faq.answer.7.3': '3) Compruebe si el nombre del punto de acceso (APN) está configurado correctamente. Vaya a Configuración-> Red e Internet-> Red móvil-> Avanzado-> Nombres de puntos de acceso-> agregar APN: net.truphone.com.',
    'faq.answer.7.4': '4) Si esta es su primera conexión, puede tardar unos minutos para SIM a conectarse.',
    'faq.answer.7.5': '5) Por favor asegúrese de que el plan de datos de precarga esté activado; si no, siga las instrucciones del paquete SIM para activarlo.',
    'faq.answer.7.6': '6) Asegúrese de que su ubicación actual esté dentro del alcance de nuestra cobertura de servicio (consulte la lista completa de países cubiertos a continuación). Mueva su dispositivo junto a una ventana o un área abierta para recibir una mejor señal.',
    'faq.answer.8': 'El plan de datos puede cubrir todos los países de la UE (Austria, Bélgica, Bulgaria, Croacia, Chipre, República Checa, Dinamarca, Estonia, Finlandia, Francia, Alemania, Grecia, Hungría, Irlanda, Italia, Letonia, Lituania, Luxemburgo, Malta, Países Bajos, Polonia, Portugal, Rumania, República Eslovaca, Eslovenia, España, Suecia), más Islandia, Noruega, Suiza, Reino Unido y Estados Unidos de América.',
    'faq.answer.8.1': 'El plan de datos puede cubrir todos los países de la UE (Austria, Bélgica, Bulgaria, Croacia, Chipre, República Checa, Dinamarca, Estonia, Finlandia, Francia, Alemania, Grecia, Hungría, Irlanda, Italia, Letonia, Lituania, Luxemburgo, Malta, Países Bajos, Polonia, Portugal, Rumania, República Eslovaca, Eslovenia, España, Suecia), más Islandia, Noruega, Suiza, Reino Unido.',
    'faq.answer.9': 'Por favor consulte a la información de contacto con nosotros de Lenovo.com en su propio país.',
    'faq.answer.10': 'El recibo se enviará automáticamente a su dirección de correo electrónico registrado después de cumplir el pedido exitosamente. Por favor compruebe tanto su buzón de entrada como su buzón de correo no deseado. Si aún no recibido, por favor comuníquese con el Servicio de atención al cliente de Lenovo.',
    'faq.answer.11': 'Si su SIM está rota, perdida o tiene fallas, por favor comuníquese con el Servicio al cliente de Lenovo para obtener una solución.',
    'faq.answer.12': 'Sí, pero se pueden solicitar cargos por servicio de mensajería. Comuníquese con el Servicio del cliente de Lenovo para obtener más detalles.',
    'faq.answer.13': 'Lo siento, el plan de datos no se puede suspender.',
    'faq.answer.14': 'Puede restablecer su contraseña a través de "Olvidar Contraseña" en la página de inicio de sesión',
    'faq.answer.15': 'Sí. Por favor comuníquese con el Servicio de cliente de Lenovo para dicha solicitud. Después de la verificación, el personal de Servicio al cliente lo ayudará a eliminar el vínculo actual entre el ICCID de la SIM y su ID de Lenovo. Tenga en cuenta que los planes de datos dentro de la validez no se pueden suspender ni reembolsar independientemente de  estado vinculante de la ID de SIM-Lenovo.',
    'faq.answer.16': 'Intente desactivar y reactivar "Datos móviles" y también reiniciar el dispositivo. Si esto no funciona, por favor comuníquese con nuestro Servicio al cliente.',
    'faq.answer.17.1': '1) Puede encontrar el ICCID en el chip SIM o en el soporte de la SIM.',
    'faq.answer.17.2': '2) Si ha activado la tarjeta SIM y precargar el plan de datos, por favor visite aoacwap.lenovoconnect.com y verifique " Yo " -> "Dispositivo "',
    'faq.answer.18': 'Por favor consulte a la información de contacto con nosotros de Lenovo.com en su propio país.',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Elegir su región',
    'contact.country.AT': 'Austria',
    'contact.country.BE': 'Bélgica',
    'contact.country.DK': 'Dinamarca',
    'contact.country.FI': 'Finlandia',
    'contact.country.FR': 'Francia',
    'contact.country.DE': 'Alemania',
    'contact.country.IE': 'Irlanda',
    'contact.country.IT': 'Italia',
    'contact.country.LUX': 'Luxemburgo',
    'contact.country.NL': 'Holanda',
    'contact.country.NO': 'Noruega',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'España',
    'contact.country.SE': 'Suecia',
    'contact.country.CH': 'Suiza',
    'contact.country.UK': 'Reino Unido',
    'contact.country.USA': 'USA',

    'contact.contactus.ES': 'Póngase en contacto con service@lenovoconnect.com para obtener detalles del pedido y servicio al cliente.',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (tarifa local)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Las llamadas a este número están cobradas conforme a la tarifa local desde un teléfono fijo y tienen un costo mínimo de 0,05 €. Las llamadas por parte de móviles pueden variar.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (Tasa Nacional)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00 Lunes - Viernes',
    'contact.workHours.BE': '9:00 - 18:00 Lunes - Viernes',
    'contact.workHours.DK': '9:00 - 18:00 Lunes - Viernes',
    'contact.workHours.FI': '9:00 - 18:00 Lunes - Viernes',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8 - 18 Uhr Lunes - Viernes',
    'contact.workHours.IE': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.IT': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.LUX': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.NL': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.NO': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.PT': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.ES': 'de 8:00h a 18:00h, de lunes a viernes',
    'contact.workHours.SE': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.CH': '9:00 - 18:00 Lunes - Viernes',
    'contact.workHours.UK': '09:00 - 18:00 Lunes - Viernes',
    'contact.workHours.USA': '00:00 - 24:00 Lunes - Domingo',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Hola',
    'bindSim.activate.title': 'Activar su Plan de Datos',
    'bindSim.tip.text1': 'Cargar la imagen del código de barras para identificar la tarjeta SIM',
    'bindSim.tip.text2': 'Activar y usar el plan de datos',
    'bindSim.btn.text': 'Cargar el imagen',
}
//平板fap
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'Q1: How do I reach Lenovo Customer Service if the following answers cannot solve my question? ',
    'faq.answer.1': 'A1: Please refer to below Customer Service information on Lenovo.com in your own country. Or directly send an email to: service@lenovoconnect.com. Please include the ICCID of the SIM in the email.',
    'faq.question.2': 'Q2: Can I make calls or send SMS?',
    'faq.answer.2': 'A2: The SIM only supports data for network. You will not receive a mobile number. It does not support voice or SMS.',
    'faq.question.3': 'Q3: Can the SIM be switched to other devices?',
    'faq.answer.3': 'A3: The SIM only can be used in the tablet. Cannot be switched to other devices.',
    'faq.question.4': 'Q4: What countries can the data plan cover? Will there be extra roaming fee?',
    'faq.answer.4': 'A4: The data plan covers all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, and United Kingdom. There is no extra roaming fee within these places.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'Q1: How can I buy a service package and check my order record? Can the unused data roll into the next 30 days?',
    'faq.answer.5': 'A1: Please visit the app "Len" preloaded on the tablet. Or visit aoacwap.lenovoconnect.com to check the data usage. If the current package is not used up, it cannot be rolled into the next 30 days.',
    'faq.question.6': 'Q2: When does the gift package start to count?',
    'faq.answer.6': 'A2: The gift package starts after the register and log in to the APP "Len", and activate the preload package on the homepage.',
    'faq.question.7': 'Q3: What are the rules of ordering connectivity service package?',
    'faq.answer.7': 'A3: Service package ordered successfully will be automatically activated (e.g. Subscribe To A Monthly Connectivity Service Package) or will wait in queue to be activated after the current service was exhausted (e.g. Add An Extra Connectivity Service Package). Service package does not support refund or suspension.',
    'faq.question.8': 'Q4: What payment methods can I use?',
    'faq.answer.8': 'A4: We support Credit/Debit Visa or Master cards in GBP, EUR, USD,CHF, NOK, DKK, SEK.',
    'faq.question.9': "Q5: I have successfully ordered the service package, why can't I use it?",
    'faq.answer.9': 'A5: If it is to add an extra connectivity service package, it can only be activated once your current package expires. If it is to subscribe to a monthly connectivity service package, it should be activated automatically. Please refer to other FAQs for connectivity issue, or contact Lenovo Customer Service or email: service@lenovoconnect.com.',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'Q1: What if I cannot find the APP or the APP was deleted by mistake?',
    'faq.answer.10': `A1: Please visit Tablet Center to re-download the APP. Or visit the link to re-download: https://aoacupg.lenovoconnect.com/common/downloadLatest`,
    'faq.question.11': "Q2: What should I do if I can't log in to the APP?",
    'faq.answer.11.1': 'A2: 1. It may take a longer time to log in to the APP for the first time. Please wait for about half a minute.',
    'faq.answer.11.2': '2. Please try to exit the APP completely and then re-enter.',
    'faq.answer.11.3': '3. If the APP registration page shows: This email has existed. Please log in directly with your previous Lenovo ID or register with a new email address.',
    'faq.answer.11.4': '4. If the APP login page shows: Card has bound by other accounts. In this case, you have already bound this card to an email account. To unbind and reset your email, please contact the customer service team or email service@lenovoconnect.com',
    'faq.question.12': 'Q3: What if I forgot my password of the registered email?',
    'faq.answer.12': 'A3: You can re-set your password via "Forgot password" on the Sign in page of the APP.',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "Q1: How should I turn off my connectivity package if I don't want to use it?",
    'faq.answer.13': 'A1：If you want to stop using cellular connectivity, please click OFF the "Mobile data". Please note that your ongoing package will NOT be suspended or refunded.',
    'faq.question.14': 'Q2：What if I cannot get Internet access?',
    'faq.answer.14.1': 'A2：1. Please check that "Settings--Network&Internet--Mobile data”is turned on.',
    'faq.answer.14.2': '2. Please check that "Settings--Network&Internet--Data roaming”is turned on (need to be turned on, there will be no additional roaming charges).ƒ',
    'faq.answer.14.3': '3. Check the "Settings-Network&Internet-Advanced-Access Point Names" are set correctly, it should be set to: lenovo.m2m.drei.at (Please add manually if there is not)',
    'faq.answer.14.4': '4. If this is your first time to connect, it may take a few minutes.',
    'faq.answer.14.5': '5. Please log in to the APP Len and confirm that the free data package has been activated. If it is not activated, please log in to the APP and click "Activation" on the main page.',
    'faq.answer.14.6': '6. Please confirm that your region is within the scope of service (please refer to the following countries for details). You can move to a more open place to receive the signal. (Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden, plus Iceland, Norway, Switzerland, and United Kingdom).',
    'faq.answer.14.7': '7. Please check whether the SIM card is installed correctly and restart the device.',
    'faq.answer.14.8': '8. Please check Settings-Network&Internet-Choose network, you can manually select the network among them. If "forbidden" is displayed after a network is found, please click and clear "forbidden" manually. If there is no forbidden displayed, you may change the SIM into your phone, acting the same process to see available networks.',
    'faq.question.15': "Q3: How do I check my SIM's ICCID?",
    'faq.answer.15.1': 'A3:  1. Please pull out the SIM card inserted in the tablet, the ICCID is on the card.',
    'faq.answer.15.2': '2. Please visit App Len-Me-Device',
    'faq.answer.15.3': '3. Please visit aoacwap.lenovoconnect.com and you will see your ICCID on the page.',
    'faq.question.16': 'Q4: How do I request a receipt for my order?',
    'faq.answer.16.1': 'A4: The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it. If still cannot find it, please contact Lenovo Customer Service or email: service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "Q1: Can I make changes after my SIM card's ICCID and my Lenovo ID are bound?",
    'faq.answer.17': 'A1: Yes. Please contact Lenovo Customer Service or email: service@lenovoconnect.com for the unbinding request. Please note that connectivity service package within validity cannot be suspended or refunded regardless of the SIM-Lenovo ID binding status.',
    'faq.question.18': 'Q2: What should I do if the card surface is damaged or lost? Can an activated service package be suspended?',
    'faq.answer.18': 'A2: If your SIM is broken or lost or faulty, please contact Lenovo Customer Service or email: service@lenovoconnect.com. We will arrange a new delivery after the confirmation of the detailed situation. The activated package cannot be suspended or refunded.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'Error de contraseña',
    'iCode.i0002': 'El buzón ya existe',
    'iCode.i0003': 'Error de formato de contraseña',
    'iCode.i0004': 'La cuenta debe estar activada antes de iniciar sesión.。',
    'iCode.i0005': 'La cuenta está desactivada',
    'iCode.i0006': 'Inicio de sesión timeout',
    'iCode.i0007': 'Error',
    'iCode.i0008': '账号或密码错误',
    'iCode.i0009': 'Por favor introduzca un código gráfico de verificación  de 5 dígitos',
    'iCode.i0010': 'La operación es demasiado frecuente. Por favor vuelva a intentarlo más tarde.',
    'iCode.i0011': 'Dirección inválida de devolución de llamada ',
    'iCode.i0012': 'Firma inválida',
    'iCode.i0013': 'Por favor Actualice el código de verificación.',
    'iCode.i0014': 'Error de servidor',
    'iCode.i0015': 'Service Good ID está vacía',
    'iCode.i0016': 'Mensaje enviado con éxito',
    'iCode.i0017': 'Mensaje enviado fracasado',
    'iCode.i0018': '兑换码错误',
    'iCode.i0019': '请在兑换期内使用',
    'iCode.i0020': '兑换码已过期',
    'iCode.i0021': '兑换码已使用',
    'iCode.i0022': '兑换码已失效',
    'iCode.i0023': 'Está creándose el pedido, por favor espere ...',
    'iCode.i0024': 'Operación fracasada',
    'iCode.i0025': '号卡不满足兑换条件',
    'iCode.i0026': 'Generación fracasada de código QR',
    'iCode.i0027': '创建升级订单信息有误',
    'iCode.i0028': 'SIM no existe',
    'iCode.i0029': '手机号格式错误',
    'iCode.i0030': '短信发送太频繁',
    'iCode.i0031': 'Error de parámetro',
    'iCode.i0032': 'El número de envío de código de verificación en un día ha alcanzado el límite superior',
    'iCode.i0033': '注册成功',
    'iCode.i0034': 'Registro fracasado de cuenta',
    'iCode.i0035': 'Por favor enlace primero SIM ICCID',
    'iCode.i0036': 'Por favor, inicie sesión en la cuenta primero',
    'iCode.i0037': 'Actualización fracasada de estado',
    'iCode.i0038': '启用中， 请稍后',
    'iCode.i0039': 'ID de pedido está vacía',
    'iCode.i0040': 'Activación en curso, por favor espere',
    'iCode.i0041': 'El paquete ya no se vende',
    'iCode.i0042': 'Activación fracasada',
    'iCode.i0043': 'Activación con éxito',
    'iCode.i0044': 'Sistema no puede identificar la SIM',
    'iCode.i0045': 'Paquete activado, no repita',
    'iCode.i0046': 'No paquetes activados',
    'iCode.i0047': 'SIM descontinuado',
    'iCode.i0048': 'Información incorrecta de paquete',
    'iCode.i0049': 'Usuario o contraseña está vacío',
    'iCode.i0050': 'No hay paquete básico para el mes',
    'iCode.i0051': 'Inicio de sesión con éxito',
    'iCode.i0052': 'Inicio de sesión anormal',
    'iCode.i0053': 'Dispositivo está va',
    'iCode.i0054': 'Error de código de verificación, por favor introduzca de nuevo',
    'iCode.i0055': 'Operación con éxito',
    'iCode.i0056': 'SIM está vacía',
    'iCode.i0057': 'Fracasado en lograr token',
    'iCode.i0058': '企业编码不存在',
    'iCode.i0059': 'El uso de la SIM es inconsistente con las propiedades de la empresa',
    'iCode.i0060': 'Por favor, no opere frecuentemente',
    'iCode.i0061': '领取优惠券成功',
    'iCode.i0062': '不满足领取条件',
    'iCode.i0063': '领取优惠券出错',
    'iCode.i0064': 'Enlace fracasado de Iccid',
    'iCode.i0065': 'La tarjeta ha sido enlazada por otra cuenta',
    'iCode.i0066': 'Enlace con éxito',
    'iCode.i0067': 'Error de Enlace',
    'iCode.i0068': 'SIM ID está vacía',
    'iCode.i0069': 'esimId为空',
    'iCode.i0070': 'No Sim enlazada',
    'iCode.i0071': 'No existe el usuario',
    'iCode.i0072': 'El apodo no puede estar vacío',
    'iCode.i0073': 'Actualizado con éxito',
    'iCode.i0074': 'Actualización fracasado',
    'iCode.i0075': 'Página de inicio no hay consulta de paquete anormal de SIM',
    'iCode.i0076': 'No disponible información pertinente',
    'iCode.i0077': 'Fracasado en generar una firma encriptada.',
    'iCode.i0078': 'Cambio fracasado',
    'iCode.i0079': 'Cambio con éxito',
    'iCode.i0080': '¡Por favor, no entregue solicitudes repetidamente!',
    'iCode.i0081': 'Por favor, refresque y pruebe de nuevo!',
    'iCode.i0082': 'Fracasado en  obtener el gráfico del banner de la página de inicio',
    'iCode.i0083': '当Actualmente no ICCID enlazado, ni un paquete preferencial',
    'iCode.i0084': 'Actualmente no ICCID enlazado, ni un paquete disponible',
    'iCode.i0085': '认证成功',
    'iCode.i0086': '认证失败',
    'iCode.i0087': 'Excepción de sistema',
    'iCode.i0088': '卡已实名',
    'iCode.i0089': 'El plan se compró con éxito',
    'iCode.i0090': 'El plan se compró fracasadamente',
    'iCode.i0091': '服务商品不存在',
    'iCode.i0092': '升级服务订单生成完毕',
    'iCode.i0093': '无升级套餐服务',
    'iCode.i0094': 'no pedido correspondiente encontrado',
    'iCode.i0095': 'no se paga el paquete actual',
    'iCode.i0096': 'ID de paquete está vacía en el pedido',
    'iCode.i0097': '套餐已启用',
    'iCode.i0098': 'Orden exitoso',
    'iCode.i0099': '暂无码号可用',
    'iCode.i0100': '无该地区码号',
    'iCode.i0104': 'Incapaz de conseguir la sub-región de la tarjeta sim',
    'iCode.i0109': 'Fracasado a leer el código de barras. Vuelva a intentarlo.',
}
export default {
    ...common,
    ...language,
    ...login,
    ...home,
    ...packageDetail,
    ...register,
    ...packageCard,
    ...billAddress,
    ...me,
    ...accountInfo,
    ...order,
    ...device,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Casa',
    'tab.text.me': 'Mía'
}
